
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.245 6a2 2 0 00-3.728-1.007l-12.245 21A2 2 0 006 29h5.823v13a2 2 0 003.73 1.003l12.177-21A2 2 0 0026 19h-5.755V6zm-6.422 19H9.481l6.764-11.6V21a2 2 0 002 2h4.283l-6.705 11.564V27a2 2 0 00-2-2zm18.74 13.718a1.922 1.922 0 002.72 2.719L38 38.719l2.718 2.718a1.922 1.922 0 102.718-2.718L40.718 36l2.719-2.718a1.922 1.922 0 00-2.718-2.719L38 33.282l-2.719-2.719a1.922 1.922 0 10-2.718 2.719L35.282 36l-2.718 2.718z","fill":"url(#paint0_linear)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":"44","y1":"24.202","x2":"4","y2":"24.202","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#7E1010"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#DE8E8E"}})])])])
          )
        }
      }
    